// SearchBarProducts helper functions and data

export const imageConfig = { width: 101, height: 101 };
